module.exports = __webpack_public_path__ + "static/media/gy.b1f77541.svg";